module.exports = __webpack_public_path__ + "static/the-art-of-the-start-20-0ae5a237f4ee5a5cc1a8905e821299d0.jpg";